export default {
  track: {
    height: 8,
    borderRadius: 4
  },
  step: {
    borderRadius: 4
  }
}
